export interface Manga {
  id: number;
  title: string;
  cover: string;
  category: string;
  tags: string[];
  status: '连载中' | '完结';
  chapters: number;
  rating: number;
  views: string;
  latest: string;
  description: string;
  isHot?: boolean;
}

export const categories = [
  { name: '热血冒险', icon: 'ri-flashlight-fill', count: 126, tone: 'primary' },
  { name: '奇幻玄幻', icon: 'ri-sparkling-2-fill', count: 98, tone: 'accent' },
  { name: '科幻机甲', icon: 'ri-rocket-2-fill', count: 74, tone: 'secondary' },
  { name: '恋爱甜宠', icon: 'ri-heart-3-fill', count: 152, tone: 'primary' },
  { name: '悬疑推理', icon: 'ri-search-eye-fill', count: 61, tone: 'secondary' },
  { name: '搞笑日常', icon: 'ri-emotion-laugh-fill', count: 88, tone: 'accent' },
  { name: '运动竞技', icon: 'ri-basketball-fill', count: 43, tone: 'primary' },
  { name: '治愈生活', icon: 'ri-plant-fill', count: 57, tone: 'accent' },
];

export const mangaList: Manga[] = [
  {
    id: 1,
    title: '炎影战纪',
    cover: 'https://readdy.ai/api/search-image?query=dynamic%20comic%20book%20cover%20of%20a%20young%20warrior%20wielding%20flaming%20blades%2C%20ember%20particles%20swirling%2C%20bold%20vermillion%20red%20and%20deep%20ink%20palette%2C%20dramatic%20action%20pose%2C%20vibrant%20chinese%20manhua%20illustration%20style%2C%20clean%20warm%20background%2C%20high%20contrast%2C%20cinematic%20lighting&width=600&height=800&seq=cover-fire-01&orientation=portrait',
    category: '热血冒险',
    tags: ['热血', '冒险', '战斗'],
    status: '完结',
    chapters: 214,
    rating: 9.6,
    views: '328万',
    latest: '第214话 最终决战',
    description: '少年炎烬从火神废墟中觉醒血脉，一路踏碎阴谋，点燃整片大陆的传奇。',
    isHot: true,
  },
  {
    id: 2,
    title: '星海拾荒人',
    cover: 'https://readdy.ai/api/search-image?query=comic%20book%20cover%20of%20a%20space%20scavenger%20in%20mechanized%20armor%20standing%20on%20an%20asteroid%2C%20distant%20nebulae%20and%20stars%2C%20warm%20orange%20and%20teal%20rim%20lighting%2C%20bold%20chinese%20manhua%20style%2C%20adventurous%20mood%2C%20rich%20detail%2C%20cinematic%20composition&width=600&height=800&seq=cover-star-02&orientation=portrait',
    category: '科幻机甲',
    tags: ['科幻', '机甲', '宇宙'],
    status: '连载中',
    chapters: 76,
    rating: 9.2,
    views: '201万',
    latest: '第76话 星门之外',
    description: '落魄拾荒人驾驶改造机甲，在破碎星系中寻找失落的母星坐标。',
    isHot: true,
  },
  {
    id: 3,
    title: '甜心咖啡屋',
    cover: 'https://readdy.ai/api/search-image?query=romantic%20comic%20cover%20of%20a%20cheerful%20barista%20girl%20holding%20a%20latte%20cup%2C%20cozy%20coffee%20shop%20interior%2C%20warm%20pastel%20coral%20and%20cream%20tones%2C%20sweet%20expression%2C%20gentle%20lighting%2C%20cute%20chinese%20manhua%20romance%20style%2C%20soft%20shadows&width=600&height=800&seq=cover-love-03&orientation=portrait',
    category: '恋爱甜宠',
    tags: ['恋爱', '甜宠', '日常'],
    status: '连载中',
    chapters: 108,
    rating: 9.4,
    views: '276万',
    latest: '第108话 心跳配方',
    description: '社恐甜点师与毒舌店长在同一家咖啡屋斗嘴又心动，甜度超标。',
    isHot: true,
  },
  {
    id: 4,
    title: '雾都侦探社',
    cover: 'https://readdy.ai/api/search-image?query=moody%20detective%20comic%20cover%2C%20sleuth%20in%20trench%20coat%20under%20street%20lamp%20in%20foggy%20night%20alley%2C%20amber%20and%20charcoal%20palette%2C%20mysterious%20atmosphere%2C%20dramatic%20chiaroscuro%20lighting%2C%20suspenseful%20chinese%20manhua%20style%2C%20high%20detail%2C%20film%20noir%20mood&width=600&height=800&seq=cover-mystery-04&orientation=portrait',
    category: '悬疑推理',
    tags: ['悬疑', '推理', '都市'],
    status: '连载中',
    chapters: 89,
    rating: 9.5,
    views: '244万',
    latest: '第89话 第十三个证人',
    description: '失忆侦探在小镇雾夜接连破解离奇案件，真相却与他的过去纠缠不清。',
  },
  {
    id: 5,
    title: '无敌菜菜子',
    cover: 'https://readdy.ai/api/search-image?query=funny%20comic%20cover%20of%20a%20cute%20schoolgirl%20with%20big%20happy%20eyes%20wearing%20oversized%20glasses%2C%20surrounded%20by%20flying%20bento%20boxes%20and%20sparkles%2C%20bright%20yellow%20and%20warm%20orange%20comedy%20palette%2C%20playful%20exaggerated%20chinese%20manhua%20comedy%20style%2C%20cheerful%20chaotic%20energy&width=600&height=800&seq=cover-comedy-05&orientation=portrait',
    category: '搞笑日常',
    tags: ['搞笑', '校园', '日常'],
    status: '连载中',
    chapters: 132,
    rating: 9.1,
    views: '189万',
    latest: '第132话 便当大作战',
    description: '干啥啥不行、干饭第一名的菜菜子，把平凡校园生活过成了大型喜剧。',
    isHot: true,
  },
  {
    id: 6,
    title: '剑来天外山',
    cover: 'https://readdy.ai/api/search-image?query=epic%20fantasy%20comic%20cover%20of%20a%20swordsman%20standing%20on%20a%20floating%20mountain%20peak%20with%20clouds%2C%20glowing%20sword%20in%20hand%2C%20warm%20sunset%20orange%20and%20vermillion%20sky%2C%20wuxia%20xianxia%20chinese%20manhua%20style%2C%20majestic%20and%20heroic%20mood%2C%20rich%20detail%2C%20cinematic&width=600&height=800&seq=cover-xuanhuan-06&orientation=portrait',
    category: '奇幻玄幻',
    tags: ['玄幻', '仙侠', '修炼'],
    status: '完结',
    chapters: 268,
    rating: 9.7,
    views: '410万',
    latest: '第268话 天外飞仙',
    description: '无名小剑童机缘入天外山，历经万难终问剑道，一剑可开天门。',
    isHot: true,
  },
  {
    id: 7,
    title: '少年球场传说',
    cover: 'https://readdy.ai/api/search-image?query=energetic%20sports%20comic%20cover%20of%20a%20teenage%20basketball%20player%20dunking%20under%20court%20lights%2C%20dust%20and%20energy%20streaks%2C%20warm%20red%20and%20orange%20competitive%20palette%2C%20dynamic%20motion%2C%20bold%20chinese%20manhua%20sports%20style%2C%20powerful%20athletic%20energy&width=600&height=800&seq=cover-sport-07&orientation=portrait',
    category: '运动竞技',
    tags: ['运动', '篮球', '青春'],
    status: '连载中',
    chapters: 54,
    rating: 9.3,
    views: '167万',
    latest: '第54话 决胜五秒',
    description: '矮个子少年凭借惊人弹跳与团队默契，一步步站上全国赛场的巅峰。',
  },
  {
    id: 8,
    title: '森屿慢生活',
    cover: 'https://readdy.ai/api/search-image?query=heartwarming%20comic%20cover%20of%20a%20girl%20relaxing%20beside%20a%20cabin%20in%20a%20sunlit%20forest%2C%20soft%20green%20and%20cream%20warm%20tones%2C%20cozy%20peaceful%20atmosphere%2C%20gentle%20morning%20light%2C%20healing%20chinese%20manhua%20style%2C%20soothing%20serene%20composition&width=600&height=800&seq=cover-heal-08&orientation=portrait',
    category: '治愈生活',
    tags: ['治愈', '生活', '慢节奏'],
    status: '完结',
    chapters: 96,
    rating: 9.4,
    views: '178万',
    latest: '第96话 山风入眠',
    description: '离开都市的插画师在森林小屋里重新学会生活，也重新遇见了自己。',
  },
  {
    id: 9,
    title: '深渊灯塔',
    cover: 'https://readdy.ai/api/search-image?query=dark%20mystery%20comic%20cover%20of%20a%20lighthouse%20on%20a%20stormy%20cliff%20with%20a%20figure%20holding%20a%20lantern%2C%20deep%20blue%20night%20and%20amber%20lantern%20glow%2C%20eerie%20tension%2C%20atmospheric%20chinese%20manhua%20thriller%20style%2C%20moody%20lighting%2C%20high%20detail&width=600&height=800&seq=cover-deep-09&orientation=portrait',
    category: '悬疑推理',
    tags: ['惊悚', '悬疑', '深海'],
    status: '连载中',
    chapters: 41,
    rating: 9.0,
    views: '132万',
    latest: '第41话 潮声来信',
    description: '灯塔守夜人接连收到来自海底的信件，海面之下藏着小镇共同的秘密。',
  },
  {
    id: 10,
    title: '机甲少年团',
    cover: 'https://readdy.ai/api/search-image?query=mecha%20comic%20cover%20of%20a%20group%20of%20teen%20pilots%20with%20giant%20robots%20in%20the%20background%2C%20warm%20sunset%20and%20metallic%20red%20accents%2C%20heroic%20mood%2C%20bold%20chinese%20manhua%20mecha%20style%2C%20dynamic%20composition%2C%20rich%20mechanical%20detail%2C%20cinematic%20glow&width=600&height=800&seq=cover-mech-10&orientation=portrait',
    category: '科幻机甲',
    tags: ['机甲', '少年', '保卫'],
    status: '完结',
    chapters: 156,
    rating: 9.2,
    views: '223万',
    latest: '第156话 最后的演习',
    description: '军校少年们驾驶机甲对抗星际异兽，在战斗中学会守护与成长。',
  },
  {
    id: 11,
    title: '仙途笑傲',
    cover: 'https://readdy.ai/api/search-image?query=wuxia%20fantasy%20comic%20cover%20of%20a%20carefree%20young%20cultivator%20with%20a%20fan%20laughing%20amidst%20flying%20swords%20and%20peach%20blossoms%2C%20warm%20pink%20and%20gold%20palette%2C%20lighthearted%20playful%20chinese%20manhua%20style%2C%20lively%20energetic%20mood%2C%20detailed&width=600&height=800&seq=cover-xian-11&orientation=portrait',
    category: '奇幻玄幻',
    tags: ['修仙', '轻松', '爽文'],
    status: '连载中',
    chapters: 120,
    rating: 9.1,
    views: '196万',
    latest: '第120话 御剑下山',
    description: '天资平平却运气爆棚的小修士，一路躺赢走上修仙人生巅峰。',
    isHot: true,
  },
  {
    id: 12,
    title: '恋爱实习手册',
    cover: 'https://readdy.ai/api/search-image?query=romance%20comic%20cover%20of%20a%20flustered%20office%20boy%20and%20cool%20senior%20colleague%20sharing%20an%20umbrella%20in%20light%20rain%2C%20warm%20peach%20and%20cream%20tones%2C%20tender%20mood%2C%20cute%20chinese%20manhua%20romance%20style%2C%20soft%20lighting%2C%20sweet%20atmosphere&width=600&height=800&seq=cover-rom-12&orientation=portrait',
    category: '恋爱甜宠',
    tags: ['恋爱', '职场', '治愈'],
    status: '连载中',
    chapters: 87,
    rating: 9.0,
    views: '154万',
    latest: '第87话 加班的心动',
    description: '在职场这场漫长的实习里，他学会了报表，也学会了好好喜欢一个人。',
  },
  {
    id: 13,
    title: '热血特工档案',
    cover: 'https://readdy.ai/api/search-image?query=action%20comic%20cover%20of%20a%20sleek%20secret%20agent%20leaping%20between%20rooftops%20with%20a%20briefcase%20and%20throwing%20stars%2C%20warm%20orange%20and%20crimson%20palette%2C%20spy%20thriller%20chinese%20manhua%20style%2C%20high%20energy%20dynamic%20pose%2C%20cinematic%20backlight&width=600&height=800&seq=cover-agent-13&orientation=portrait',
    category: '热血冒险',
    tags: ['动作', '特工', '冒险'],
    status: '完结',
    chapters: 134,
    rating: 9.2,
    views: '240万',
    latest: '第134话 档案封存',
    description: '天才特工档案逐一解锁，每份机密背后都是一段惊心动魄的任务。',
  },
  {
    id: 14,
    title: '猫咪房东日记',
    cover: 'https://readdy.ai/api/search-image?query=adorable%20comic%20cover%20of%20a%20group%20of%20cats%20sitting%20on%20a%20window%20sill%20of%20a%20cozy%20apartment%2C%20warm%20amber%20and%20cream%20tones%2C%20soft%20afternoon%20light%2C%20gentle%20funny%20chinese%20manhua%20daily%20life%20style%2C%20cute%20and%20heartwarming%2C%20soft%20shadows&width=600&height=800&seq=cover-cat-14&orientation=portrait',
    category: '治愈生活',
    tags: ['治愈', '萌宠', '日常'],
    status: '连载中',
    chapters: 63,
    rating: 9.3,
    views: '172万',
    latest: '第63话 新室友报到',
    description: '单身房东的合租屋来了四位毛茸茸房客，房租用猫粮和踩奶结清。',
  },
  {
    id: 15,
    title: '天才棋士手',
    cover: 'https://readdy.ai/api/search-image?query=dramatic%20comic%20cover%20of%20a%20young%20go%20prodigy%20focused%20at%20a%20go%20board%20under%20warm%20spotlight%2C%20flying%20chess%20stones%20and%20energy%2C%20warm%20vermillion%20and%20ink%20palette%2C%20intense%20concentration%2C%20chinese%20manhua%20sports%2Fstrategic%20style%2C%20dramatic%20lighting&width=600&height=800&seq=cover-go-15&orientation=portrait',
    category: '运动竞技',
    tags: ['棋类', '竞技', '成长'],
    status: '完结',
    chapters: 102,
    rating: 9.4,
    views: '143万',
    latest: '第102话 一子定乾坤',
    description: '天才棋手从街头对弈一路杀入世界大赛，以一手妙棋震撼棋坛。',
  },
  {
    id: 16,
    title: '爆笑朋友圈',
    cover: 'https://readdy.ai/api/search-image?query=hilarious%20comic%20cover%20of%20a%20group%20of%20silly%20friends%20in%20a%20cafeteria%20with%20flying%20food%20and%20laughing%20screams%2C%20bright%20warm%20yellow%20and%20orange%20comedy%20palette%2C%20chaotic%20fun%2C%20exaggerated%20expressions%2C%20chinese%20manhua%20comedy%20style%2C%20playful%20energy&width=600&height=800&seq=cover-haha-16&orientation=portrait',
    category: '搞笑日常',
    tags: ['搞笑', '校园', '友情'],
    status: '连载中',
    chapters: 98,
    rating: 9.0,
    views: '168万',
    latest: '第98话 期末名场面',
    description: '五个损友的日常永远鸡飞狗跳，笑点密集到根本停不下来。',
    isHot: true,
  },
  {
    id: 17,
    title: '龙裔觉醒',
    cover: 'https://readdy.ai/api/search-image?query=epic%20fantasy%20comic%20cover%20of%20a%20hero%20with%20glowing%20dragon%20scales%20on%20his%20arm%20facing%20a%20storm%20sky%20with%20a%20dragon%20silhouette%2C%20warm%20crimson%20and%20gold%20palette%2C%20legendary%20chinese%20manhua%20fantasy%20style%2C%20majestic%20epic%20mood%2C%20cinematic%20lighting&width=600&height=800&seq=cover-dragon-17&orientation=portrait',
    category: '奇幻玄幻',
    tags: ['玄幻', '觉醒', '热血'],
    status: '连载中',
    chapters: 79,
    rating: 9.3,
    views: '210万',
    latest: '第79话 龙血沸腾',
    description: '平凡青年体内沉睡的龙裔血脉觉醒，从此踏上传奇与抗争之路。',
    isHot: true,
  },
  {
    id: 18,
    title: '午夜便利店',
    cover: 'https://readdy.ai/api/search-image?query=cozy%20comic%20cover%20of%20a%20night%20convenience%20store%20glowing%20warm%20in%20a%20quiet%20street%2C%20a%20clerk%20and%20a%20cat%20at%20the%20counter%2C%20warm%20amber%20and%20cream%20tones%2C%20gentle%20midnight%20peace%2C%20healing%20chinese%20manhua%20daily%20life%20style%2C%20soft%20glowing%20atmosphere&width=600&height=800&seq=cover-midnight-18&orientation=portrait',
    category: '治愈生活',
    tags: ['治愈', '深夜', '温暖'],
    status: '连载中',
    chapters: 71,
    rating: 9.2,
    views: '158万',
    latest: '第71话 凌晨三点的客人',
    description: '凌晨的便利店收留每个疲惫的人，也收藏每一段温暖的小故事。',
  },
];

export const faqList = [
  {
    q: '嘿休漫画网址多久更新一次作品库？',
    a: '作品库持续扩充，每日会新增并更新多部漫画的章节与分类信息，热门作品与最新更新都会优先同步，方便你第一时间看到想看的内容。',
  },
  {
    q: '如何快速找到想看的漫画？',
    a: '你可以在首屏搜索框输入作品名或关键词，也可以直接点击分类导航浏览；人气排行和热门推荐板块已按热度整理，翻起来更省时。',
  },
  {
    q: '人气排行是按什么标准排序的？',
    a: '排行综合了作品的阅读热度、收藏量与近期更新时间，力求更真实地反映当前读者的关注度，榜单会随热度变化定期刷新。',
  },
  {
    q: '分类是如何划分的？会不会重复推荐？',
    a: '每部作品会依据核心主题归入主要分类，同一部作品也可能出现在热门推荐或人气排行等板块中，这属于正常的多角度推荐。',
  },
  {
    q: '可以在手机上看吗？',
    a: '可以，本站针对电脑、平板和手机都做了响应式适配，手机端同样支持搜索、分类筛选与排行浏览，操作流畅方便。',
  },
  {
    q: '作品信息如果和我看到的不一致怎么办？',
    a: '我们会持续校核章节、状态与简介等信息。若发现个别作品数据有出入，欢迎通过页脚联系方式反馈，我们会尽快修正。',
  },
];

export const testimonials = [
  {
    name: '阿黎',
    role: '热血党 · 追更 3 年',
    text: '分类做得清楚，炎影战纪和剑来天外山都是在这儿追完的，排行榜基本没踩过雷。',
    stars: 5,
  },
  {
    name: '小星',
    role: '恋爱漫爱好者',
    text: '甜心咖啡屋、恋爱实习手册一眼就戳中我，按分类翻找特别省时，治愈系专区常驻。',
    stars: 5,
  },
  {
    name: '老周',
    role: '上班族 · 通勤党',
    text: '手机上刷很方便，更新也快，午休和通勤摸鱼全靠嘿休漫画的排行榜打发时间。',
    stars: 4,
  },
  {
    name: '南瓜',
    role: '悬疑推理迷',
    text: '雾都侦探社和深渊灯塔都强推，推理向虽然作品不多但个个能打，置顶收藏了。',
    stars: 5,
  },
];